import {combineReducers} from "redux"
import {writerReducer} from "./WriterReducer"

export default combineReducers({
	writerReducer,
})
